import ImagesGalleryModal from './ImagesGalleryModal'

export default ImagesGalleryModal
